import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";
import utilityVariables from "ui-v2/styles/utility_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue =
    semanticVariables?.[`semantic_icon_${color}`] ||
    utilityVariables?.[`utility_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_14100_33962)">
        <path
          d="M12.6673 9.73158C12.6673 12.4575 10.578 14.6673 8.00065 14.6673C5.42332 14.6673 3.33398 12.4575 3.33398 9.73158C3.33398 7.02323 5.95037 4.07425 7.38927 1.99068C7.69131 1.55331 7.84233 1.33463 7.99959 1.33399C8.15686 1.33334 8.30997 1.55148 8.6162 1.98776C10.056 4.03899 12.6673 6.88528 12.6673 9.73158Z"
          fill={colorValue}
          fill-opacity="0.523"
        />
      </g>
      <defs>
        <clipPath id="clip0_14100_33962">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
